import { Layout, Menu } from 'antd'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Color } from '../../Common/Color'
import { LeftOutlined } from '@ant-design/icons'
import EventComments from './EventComments'
import EventDescription from './EventDescription'

const { Header, Content } = Layout

export default function EventDetail ({ event, updateEventRequest, updateEvent, showEvent, addComment, inCharge }) {
  const [comments, setComments] = useState([])
  useEffect(() => {
    showEvent()
  }, [])

  useEffect(() => {
    setComments(event?.comments || [])
  }, [event])

  const navigate = useNavigate()
  const back = () => navigate('/admin/events')
  const [displayPanel, setDisplayPanel] = useState('description')
  const title = <div style={{ flexDirection: 'row', display: 'flex' }}>
    <LeftOutlined onClick={back} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
    <span>{event.title}</span>
  </div>

  const items = () => [
    {
      key: 'description', label: (<Link onClick={() => (setDisplayPanel('description'))}>{t('Admin.Event.description')}</Link>)
    },
    {
      key: 'comment', label: (<Link onClick={() => (setDisplayPanel('log'))}>{t('Admin.Event.comments')}</Link>)
    }
  ]
  return (
    <>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>{title}</Layout>
      <Header style={{ padding: 0, backgroundColor: Color.white, color: Color.dark_blue }}>
        <Menu style={{ float: 'left', backgroundColor: Color.white, color: Color.dark_blue, width: '100%' }}
          onClick={(e) => setDisplayPanel(e.key)}
          selectedKeys={[displayPanel]}
          mode='horizontal'
          items={items()} />
      </Header>
      <Content style={{ padding: '1em', backgroundColor: 'white' }}>
        {displayPanel === 'description' && <EventDescription event={event} mobile={true} updateEventRequest={updateEventRequest} updateEvent={updateEvent} inCharge={inCharge} />}
        {displayPanel === 'comment' && <EventComments event={event} comments={comments} addComment={addComment}/>}
      </Content>
    </>
  )
}
